/*eslint-disable*/
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import SectionFooter from "views/footer/PageFooter.js";

import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import presentationStyle from "assets/jss/material-kit-pro-react/views/echosup/SecretaireMedicaleStyle.js";

import logo_ecosup from "assets/img/ecosup.png";
import imgVae from "assets/img/vae.webp";

const useStyles = makeStyles(presentationStyle);

export default function VaePage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const classes = useStyles();
  return (
    <div>
      <Helmet>
        <title>VAE Toulon - Validation des Acquis de l'Expérience | EcoSup</title>
        <meta name="description" content="VAE à Toulon avec EcoSup. Faites valider vos acquis pour obtenir la certification Secrétaire Médical(e) ou Assistant(e) Juridique." />
        <link rel="canonical" href="https://www.ecosup-toulon.fr/vae" />
      </Helmet>
      <Header
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 50,
          color: "white"
        }}
      />
      <Parallax
        image={require("assets/img/campus2.jpg")}
        className={classes.parallax}
        filter="dark"
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <GridContainer justify="center" alignItems="center">
                  <GridItem xs={8} sm={4} md={4}>
                    <img
                      src={logo_ecosup} alt="EcoSup Toulon" className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={8} md={8}>
                    <h1 className={classes.title}>
                      Validation des Acquis de l'Expérience (VAE)
                    </h1>
                  </GridItem>
                </GridContainer>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.section}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={8}>
                <h5 className={classes.description}>
                  Obtenez la certification de niveau 4 de{" "}
                  <Link to="/secretaire-medicale">secrétaire médical(e)</Link>
                  {" "}ou d'<Link to="/juridique">assistant(e) juridique</Link>
                  {" "}de niveau 5 en adéquation avec votre expérience professionnelle grâce à notre dispositif VAE.
                </h5>
                <p className={classes.description}>
                  La Validation des Acquis de l'Expérience (VAE) est un dispositif qui permet à toute personne de faire reconnaître officiellement les compétences et savoir-faire acquis au cours de ses expériences professionnelles, personnelles ou bénévoles, en vue d'obtenir tout ou partie d'un diplôme, d'un titre professionnel ou d'un certificat de qualification professionnelle inscrit au Répertoire National des Certifications Professionnelles (RNCP). Cette voie est équivalente à l'obtention par la formation initiale, la formation continue ou l'apprentissage.
                </p>

                <h3 className={classes.cardTitle}>À qui s'adresse la VAE ?</h3>
                <p className={classes.description}>
                  La VAE est ouverte à toutes les personnes ayant acquis une expérience significative, peu importe :
                </p>
                <p className={classes.description}>
                  - l'âge, le niveau de diplôme ou le statut (salarié, indépendant, demandeur d'emploi, bénévole…) ;
                </p>
                <p className={classes.description}>
                  - la nature de l'expérience (professionnelle, personnelle ou associative), dès lors qu'elle est en lien avec les compétences requises pour la certification visée.
                </p>

                <h3 className={classes.cardTitle}>Pourquoi recourir à la VAE ?</h3>
                <p className={classes.description}>
                  La VAE répond à un besoin fréquent : valoriser les compétences réelles acquises sur le terrain par une certification reconnue par l'État. Elle constitue un levier pour :
                </p>
                <p className={classes.description}>
                  - faire évoluer sa carrière ou obtenir une promotion ;
                </p>
                <p className={classes.description}>
                  - faire reconnaître son expertise sans retourner en formation initiale ;
                </p>
                <p className={classes.description}>
                  - se reconvertir ou renforcer son employabilité.
                </p>
                <p className={classes.description}>
                  La réforme France VAE prévoit un parcours simplifié et plus accessible, avec accompagnement possible dès l'envoi de la candidature.
                </p>

                <h3 className={classes.cardTitle}>Indicateurs de résultats VAE 2025</h3>
                <br/>
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "30px", borderRadius: "6px", overflow: "hidden" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#00acc1", color: "#fff" }}>
                      <th colSpan={2} style={{ padding: "12px 16px", fontSize: "16px", textAlign: "center" }}>
                        Secrétaire Médical·e
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ backgroundColor: "#f5f5f5" }}>
                      <td style={{ padding: "10px 16px", borderBottom: "1px solid #e0e0e0" }}>Taux de réussite</td>
                      <td style={{ padding: "10px 16px", borderBottom: "1px solid #e0e0e0", textAlign: "right", fontWeight: "bold" }}>100% <span style={{ fontWeight: "normal", fontSize: "13px" }}>(8 candidats accompagnés, 8 certifiés)</span></td>
                    </tr>
                    <tr>
                      <td style={{ padding: "10px 16px", borderBottom: "1px solid #e0e0e0" }}>Taux de satisfaction</td>
                      <td style={{ padding: "10px 16px", borderBottom: "1px solid #e0e0e0", textAlign: "right", fontWeight: "bold" }}>100%</td>
                    </tr>
                    <tr style={{ backgroundColor: "#f5f5f5" }}>
                      <td style={{ padding: "10px 16px" }}>Taux d{"'"}obtention totale de certification</td>
                      <td style={{ padding: "10px 16px", textAlign: "right", fontWeight: "bold" }}>100%</td>
                    </tr>
                  </tbody>
                </table>

                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px", borderRadius: "6px", overflow: "hidden" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#00acc1", color: "#fff" }}>
                      <th colSpan={2} style={{ padding: "12px 16px", fontSize: "16px", textAlign: "center" }}>
                        Assistant·e Juridique
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ backgroundColor: "#f5f5f5" }}>
                      <td style={{ padding: "10px 16px", borderBottom: "1px solid #e0e0e0" }}>Taux de réussite</td>
                      <td style={{ padding: "10px 16px", borderBottom: "1px solid #e0e0e0", textAlign: "right", fontWeight: "bold" }}>100% <span style={{ fontWeight: "normal", fontSize: "13px" }}>(1 candidat accompagné, 1 certifié)</span></td>
                    </tr>
                    <tr>
                      <td style={{ padding: "10px 16px", borderBottom: "1px solid #e0e0e0" }}>Taux de satisfaction</td>
                      <td style={{ padding: "10px 16px", borderBottom: "1px solid #e0e0e0", textAlign: "right", fontWeight: "bold" }}>100%</td>
                    </tr>
                    <tr style={{ backgroundColor: "#f5f5f5" }}>
                      <td style={{ padding: "10px 16px" }}>Taux d{"'"}obtention totale de certification</td>
                      <td style={{ padding: "10px 16px", textAlign: "right", fontWeight: "bold" }}>100%</td>
                    </tr>
                  </tbody>
                </table>

                <h3 className={classes.cardTitle}>La plateforme France VAE</h3>
                <p className={classes.description}>
                  La plateforme{" "}
                  <a href="https://vae.gouv.fr/" target="_blank" rel="noopener noreferrer">France VAE</a>
                  , dans le cadre de la réforme du dispositif, a pour objectif de simplifier, sécuriser et moderniser le parcours VAE. Elle permet de déposer sa candidature, de suivre son parcours et d'être accompagné dans les démarches via une interface unique et centralisée.
                </p>
                <p className={classes.description}>
                  Si vous souhaitez engager une démarche VAE, la plateforme{" "}
                  <a href="https://vae.gouv.fr/" target="_blank" rel="noopener noreferrer">France VAE</a>
                  {" "}vous guide pas à pas pour vérifier l'éligibilité de la certification, déposer votre candidature en ligne et suivre l'accompagnement jusqu'à l'évaluation finale par un jury.
                </p>
                <br/>
                <div className={classes.buttonCenter}>
                  <Button color="info" round href="https://vae.gouv.fr/" target="_blank">
                    <OpenInNewIcon /> Accéder à France VAE
                  </Button>
                </div>

                <h3 className={classes.cardTitle}>À noter</h3>
                <p className={classes.description}>
                  Certains publics, comme les salariés du secteur public ou ceux visant des certifications non encore disponibles sur la plateforme France VAE, peuvent suivre un parcours antérieur ou spécifique en dehors de cette plateforme.
                </p>

              </GridItem>

              <GridItem xs={12} sm={12} md={4}>
                <img
                  src={imgVae}
                  alt="Validation des Acquis de l'Expérience"
                  style={{ maxWidth: "100%", height: "auto", borderRadius: "6px", marginBottom: "20px" }}
                />
                <Card style={{ backgroundColor: "#00acc1", color: "#fff", textAlign: "center" }}>
                  <CardBody>
                    <h3 className={classes.cardTitleWhite} style={{ marginBottom: "20px" }}>Certifications accessibles par VAE</h3>
                    <p className={classes.cardDescriptionWhite}>
                      Secrétaire Médical(e) — Niveau 4
                    </p>
                    <p className={classes.cardDescriptionWhite}>
                      Assistant(e) Juridique — Niveau 5
                    </p>
                    <Button color="white" round component={Link} to="/contact">
                      Nous contacter
                    </Button>
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <SectionFooter date={"13 Février 2026"} />
    </div>
  );
}
